import React from "react";
import GanttChart from "./GanttChart";

export default function ActivityView({ activity, ganttData }) {
  if (!activity) return null;

  return (
    <div className="space-y-4">
      {/* ✅ 간트차트 */}
      <div className="bg-white border rounded-xl p-5 shadow-sm">
        <h4 className="font-semibold text-gray-800 mb-3">관련 공정 간트차트</h4>
        <GanttChart tasks={ganttData} />
      </div>

      {/* ✅ 기본 정보 */}
      {/* <div className="bg-white border rounded-xl p-5 shadow-sm">
        <h4 className="font-semibold text-gray-800 mb-3">공정 기본 정보</h4>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-500">진도율</p>
            <p className="font-medium text-gray-800">
              {activity.percent_complete}%
            </p>
          </div>
          <div>
            <p className="text-gray-500">상태</p>
            <span
              className={`inline-block px-2 py-1 rounded-md text-xs font-semibold
                ${activity.status === "DELAY" ? "bg-red-100 text-red-600" :
                  activity.status === "DONE" ? "bg-green-100 text-green-600" :
                    "bg-blue-100 text-blue-600"}`}
            >
              {activity.status}
            </span>
          </div>
        </div>
      </div> */}

      {/* ✅ 날짜 비교 (Baseline vs Actual) */}
      <div className="bg-white border rounded-xl p-5 shadow-sm">
        <h4 className="font-semibold text-gray-800 mb-3">일정 비교</h4>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border border-gray-200 rounded-lg">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-2 text-left text-gray-600">구분</th>
                <th className="p-2 text-center text-gray-600">시작일</th>
                <th className="p-2 text-center text-gray-600">완료일</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr>
                <td className="p-2 font-medium text-gray-700">Baseline</td>
                <td className="p-2 text-center">
                  {activity.baseline_start_date?.slice(0, 10) || "-"}
                </td>
                <td className="p-2 text-center">
                  {activity.baseline_finish_date?.slice(0, 10) || "-"}
                </td>
              </tr>
              <tr>
                <td className="p-2 font-medium text-gray-700">현재</td>
                <td className="p-2 text-center">
                  {activity.start?.slice(0, 10) || "-"}
                </td>
                <td className="p-2 text-center">
                  {activity.end?.slice(0, 10) || "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
